export default __webpack_public_path__ + "app/module/eficiencia-fiscal/view/configuracao/codigo-barras-ncm/index.html";